module.exports = __webpack_public_path__ + "media/img/flags/China-933a5fd60bc9e9b3f152937065ba2142.png";